import { useCallback, useEffect, useRef } from 'react';

/**
 * Hook that will help dealing with mounted state of component.
 */
export const useMounted = (): (() => boolean) => {
    const mountedRef = useRef<boolean>(false);
    const isMounted = useCallback((): boolean => mountedRef.current, [mountedRef.current]);

    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    });

    return isMounted;
};
